'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AvatarSize = {
  EXTRA_SMALL: 'xs',
  SMALL: 'sm',
  MEDIUM: 'md',
  LARGE: 'lg',
  EXTRA_LARGE: 'xl'
};
exports.default = AvatarSize;
module.exports = exports['default'];